import React from "react";
import { Link } from "react-router-dom";

function HeroSection() {
  return (
    <div>
      <section className="hero-section style-three">
        <div className="swiper hero-three-swiper">
          <div className="swiper-wrapper">
            {/* Hero Slide */}
            <div
              className="swiper-slide active-slide jarallax"
              data-jarallax
              data-speed="0.2"
              style={{ backgroundImage: "url('assets/img/bg-img/35.jpg')" }}
            >
              <div className="container h-100">
                <div className="row h-100 justify-content-center align-items-center">
                  <div className="col-12 col-lg-7 hero3-slide-content">
                    <div
                      className="h5 mb-3 text-white"
                      data-fade-in-up
                      data-animation-delay="300ms"
                    >
                      We provide professional Law services
                    </div>
                    <h2
                      data-fade-in-up
                      data-animation-delay="700ms"
                      className="mb-5"
                    >
                      Trusted Partners in Achieving Legal Success
                    </h2>
                    <Link
                      to="/blogone"
                      className="btn btn-primary"
                      data-fade-in-up
                      data-animation-delay="1100ms"
                    >
                      <span>
                        Book Consultation{" "}
                        <i className="ti ti-arrow-up-right"></i>
                      </span>
                      <span>
                        Book Consultation{" "}
                        <i className="ti ti-arrow-up-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Hero Slide */}
            <div
              className="swiper-slide jarallax"
              data-jarallax
              data-speed="0.2"
              style={{ backgroundImage: "url('assets/img/bg-img/1.jpg')" }}
            >
              <div className="container h-100">
                <div className="row h-100 justify-content-center align-items-center">
                  <div className="col-12 col-lg-7 hero3-slide-content">
                    <div
                      className="h5 mb-3 text-white"
                      data-fade-in-up
                      data-animation-delay="300ms"
                    >
                      Expert Legal Solutions for Every Need
                    </div>
                    <h2
                      data-fade-in-up
                      data-animation-delay="700ms"
                      className="mb-5"
                    >
                      Your Trusted Partner in Legal Excellence
                    </h2>
                    <Link
                      to="/blogone"
                      className="btn btn-primary"
                      data-fade-in-up
                      data-animation-delay="1100ms"
                    >
                      <span>
                        Book Consultation{" "}
                        <i className="ti ti-arrow-up-right"></i>
                      </span>
                      <span>
                        Book Consultation{" "}
                        <i className="ti ti-arrow-up-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-three-button-prev">
            <i className="ti ti-arrow-left"></i>
          </div>
          <div className="hero-three-button-next">
            <i className="ti ti-arrow-right"></i>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HeroSection;
